import { useQuery } from "@tanstack/vue-query";
import { Ref } from "vue";

import { ConsumptionQueryKeys } from "@/data/api/kili/consumption/consumption-query-keys";
import { TMultisiteConsumptionRequest } from "@/data/api/kili/consumption/types/multisite-consumption.type";
import KiliApi from "@/data/api/kili/kili-api";

export function useGetMultisiteConsumptionMissingInfosQuery(siteIds: Ref<TMultisiteConsumptionRequest["siteIds"]>) {
  return useQuery({
    queryKey: ConsumptionQueryKeys.multisiteConsumptionMissingInfos(siteIds),
    queryFn: () =>
      KiliApi.getMultisiteConsumptionMissingInfos({
        queries: { siteIds: siteIds.value ?? undefined },
      }),
  });
}
